export default {
  title: 'Ajuda e FAQs',
  buttons: {
    faqs: 'FAQs',
    contact_us: 'Contacte-nos',
  },
};
